import { useEffect, useState } from "react";
import api from "../../services/api";

const COLORS = {
  primary: "#0D47A1",
  profit: "#16A34A",
  danger: "#D32F2F",
  bg: "#FFF6EA",
  card: "#FFFFFF",
  border: "#E0E0E0",
  text: "#1E1E1E",
  muted: "#757575",
};

const DayBook = () => {

  const [date,setDate] = useState(
    new Date().toISOString().slice(0,10)
  );

  const [data,setData] = useState([]);

  const load = async () => {

    try{

      const res = await api.get(`/daybook/list.php?date=${date}`);

      setData(res.data?.data || []);

    }catch(err){
      console.error(err);
    }

  };

  useEffect(()=>{
    load();
  },[date]);

  const totalDebit = data.reduce(
    (sum,row)=> sum + Number(row.debit || 0),0
  );

  const totalCredit = data.reduce(
    (sum,row)=> sum + Number(row.credit || 0),0
  );

  const netTotal = totalCredit - totalDebit;

  return(

    <div style={styles.page}>

      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Day Book</h2>
          <div style={styles.subtitle}>
            Daily transaction summary
          </div>
        </div>

        <input
          type="date"
          value={date}
          onChange={(e)=>setDate(e.target.value)}
          style={styles.input}
        />
      </div>

      {/* SUMMARY */}

      <div style={styles.summaryGrid}>

        <SummaryCard
          title="Net Total"
          amount={netTotal}
          color={COLORS.primary}
        />

        <SummaryCard
          title="Money In"
          amount={totalCredit}
          color={COLORS.profit}
        />

        <SummaryCard
          title="Money Out"
          amount={totalDebit}
          color={COLORS.danger}
        />

      </div>

      {/* TABLE */}

      <div style={styles.card}>

        <div style={styles.tableWrap}>

          <table style={styles.table}>

            <thead>
              <tr>
<th style={styles.th}>Party</th>
<th style={styles.th}>Type</th>
<th style={styles.th}>Credit</th>
<th style={styles.th}>Debit</th>
              </tr>
            </thead>

            <tbody>

              {data.length === 0 && (
                <tr>
                  <td colSpan="4" style={styles.td}>
                    No transactions found
                  </td>
                </tr>
              )}

              {data.map((row,index)=>(

                <tr key={`${row.type}-${row.date}-${index}`}>

                 <td style={styles.td}>
  {row.party_name || "-"}
</td>

<td style={{
  ...styles.td,
  fontWeight:500
}}>
  {row.type === "Sale Payment" && "Sale (Paid)"}
{row.type === "Payment In" && "Payment Received"}
{row.type === "Payment Out" && "Payment Given"}
{row.type === "Purchase Payment" && "Purchase (Paid)"}
</td>

                  <td style={{
                    ...styles.td,
                    color:COLORS.profit
                  }}>
                    ₹ {Number(row.credit || 0).toFixed(2)}
                  </td>

                  <td style={{
                    ...styles.td,
                    color:COLORS.danger
                  }}>
                    ₹ {Number(row.debit || 0).toFixed(2)}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );
};

const SummaryCard = ({title,amount,color}) => (

  <div style={styles.summaryCard}>

    <div style={styles.summaryLabel}>
      {title}
    </div>

    <div style={{
      ...styles.summaryValue,
      color
    }}>
      ₹ {Number(amount).toFixed(2)}
    </div>

  </div>

);

/* ================= RESPONSIVE STYLES ================= */

const styles = {

  page:{
    background:COLORS.bg,
    padding:"20px clamp(15px,4vw,30px)",
    minHeight:"100vh"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    flexWrap:"wrap",
    gap:12,
    marginBottom:25
  },

  title:{
    fontSize:26,
    fontWeight:700
  },

  subtitle:{
    color:COLORS.muted
  },

  input:{
    padding:10,
    borderRadius:6,
    border:`1px solid ${COLORS.border}`,
    minWidth:180
  },

  summaryGrid:{
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",
    gap:20,
    marginBottom:25
  },

  summaryCard:{
    background:COLORS.card,
    padding:20,
    borderRadius:12,
    border:`1px solid ${COLORS.border}`
  },

  summaryLabel:{
    color:COLORS.muted,
    marginBottom:6
  },

  summaryValue:{
    fontSize:22,
    fontWeight:600
  },

  card:{
    background:COLORS.card,
    padding:20,
    borderRadius:12,
    border:`1px solid ${COLORS.border}`
  },

  tableWrap:{
    overflowX:"auto"
  },

  table:{
    width:"100%",
    borderCollapse:"collapse",
    minWidth:500
  },

  th:{
    textAlign:"left",
    padding:12,
    borderBottom:`1px solid ${COLORS.border}`
  },

  td:{
    padding:12,
    borderBottom:`1px solid ${COLORS.border}`
  }

};

export default DayBook;